import { Observable, pipe, OperatorFunction } from "rxjs"
import { filter, startWith, debounceTime, distinctUntilChanged, map } from "rxjs/operators";

export function valueChangesPipe(stream: Observable<any>): Observable<any> {
  return stream.pipe(
    startWith(''),
    filter((value: string) => typeof value === 'string'),
    debounceTime(200),
    distinctUntilChanged()
  );
}

export function normalizedSearch(
  wait = 500,
  minLength = 2
): OperatorFunction<string, string> {
  return pipe(
    debounceTime(wait),
    filter((value): value is string => typeof value === 'string'),
    map((value: string) => (value && value.trim().length > minLength ? value.trim() : '')),
    distinctUntilChanged()
  );
}
